<template>
  <div class="home">
    <swiper />
    <div class="home-title">
      <p>新闻中心</p>
      <div class="home-title-line"></div>
    </div>
    <NewList />
    <!-- <div class="he50"></div> -->
    <div class="home-title">
      <p>关于我们</p>
      <div class="home-title-line"></div>
    </div>
    <about />
    <div class="he50"></div>
    <div class="home-title">
      <p>会员单位展示</p>
      <div class="home-title-line"></div>
    </div>
    <vipLink />
    <!-- <div class="he50"></div> -->
    <div class="home-title">
      <p>《航海》阅读</p>
      <div class="home-title-line"></div>
    </div>
    <bookList />
    <div class="he50"></div>
    <!-- <div class="he50"></div> -->
  </div>
</template>

<script>
import swiper from "@/components/pc/home/swiper.vue";
import about from "@/components/pc/home/about.vue";
import vipLink from "@/components/pc/home/vipLink.vue";
import bookList from "@/components/pc/home/bookList.vue";
import NewList from "@/components/pc/home/new.vue";

export default {
  name: "PcHome",
  components: {
    swiper,
    about,
    vipLink,
    bookList,
    NewList
  }
};
</script>

<style lang="less">
.home {
  &-title {
    margin-top: 60px;
    // margin-bottom: 60px;
    width: 100%;
    letter-spacing: 10px;
    text-align: center;
    p {
      font-size: 40px;
      font-weight: 400;
      color: rgba(33, 43, 53, 1);
    }
    &-line {
      margin: 30px auto;
      width: 90px;
      height: 3px;
      background: rgba(108, 44, 102, 1);
    }
  }
  &-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 220px;
    height: 60px;
    padding: 20px 35px;
    box-sizing: border-box;
    border: 2px solid rgba(108, 44, 102, 1);
    font-size: 18px;
    font-weight: 400;
    color: rgba(108, 44, 102, 1);
    cursor: pointer;
  }
  &-button:hover {
    background: rgba(108, 44, 102, 1);
    color: #fff;
  }
}
</style>
